import TextPage from 'routes/components/TextPage/TextPage'
import { TermsOfServiceMarkdown } from 'routes/components/TermsOfServiceMarkdown/TermsOfServiceMarkdown'

const TermsOfService = () => (
  <TextPage title="Settle Terms of Service">
    <TermsOfServiceMarkdown />
  </TextPage>
)

export default TermsOfService
